import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { NgxSpinnerModule } from 'ngx-spinner';
import { provideToastr } from 'ngx-toastr';
import { providePrimeNG } from 'primeng/config';

import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authTokenInterceptor } from './iterceptors/auth-token.interceptor';
import { spinnerInterceptor } from './iterceptors/spinner.interceptor';
// 🔹 i18n imports

// ✅ Factory for TranslateHttpLoader
// factory function
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
// 🔹 i18n imports
import { credentialsInterceptor } from './iterceptors/credentials.interceptor';

// ✅ Factory for TranslateHttpLoader
// factory function

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f0eefd',
      100: '#dddaf9',
      200: '#b4b0ef',
      300: '#867fdf',
      400: '#5f53c8',
      500: '#080032', // ✅ Your exact base color
      600: '#06002b',
      700: '#050024',
      800: '#04001d',
      900: '#030017',
      950: '#01000c',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // provideHttpClient(
    //   withInterceptors([authTokenInterceptor, spinnerInterceptor]) // Register the interceptor here
    // ),
    provideHttpClient(
      withInterceptors([credentialsInterceptor, authTokenInterceptor, spinnerInterceptor]) // Register the interceptor here
    ),
    provideAnimations(),
    provideToastr(),
    NgxSpinnerModule,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideMessaging(() => getMessaging()),
    provideAuth(() => getAuth()),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    }),
    DatePipe,
  ],
};
